module.exports = __webpack_public_path__ + "static/media/posBackground.3eec60ba.svg";